import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-aqi-card',
  templateUrl: './aqi-card.component.html',
})
export class AqiCardComponent {
  @Input({required: true, alias: 'aqiData'}) aqiData!: any;
  aqiRanges = [
    { label: 'Good', min: 0, max: 50, color: '#2ecc71' },
    { label: 'Moderate', min: 51, max: 100, color: '#f1c40f' },
    { label: 'Poor', min: 101, max: 150, color: '#e67e22' },
    { label: 'Unhealthy', min: 151, max: 200, color: '#e74c3c' },
    { label: 'Severe', min: 201, max: 300, color: '#9b59b6' },
    { label: 'Hazardous', min: 301, max: 500, color: '#c0392b' },
  ];

  get currentAqi(): number {
    return this.aqiData?.['aqi'] || 0;
  }

  getAqiRange(aqi: number): any {
    if (aqi == null || isNaN(aqi)) return { label: 'Good', min: 0, max: 50, color: '#2ecc71' };
    const range = this.aqiRanges.find(r => aqi >= r.min && aqi <= r.max);
    return range || { label: 'Good', min: 0, max: 50, color: '#2ecc71' };
  }
}